import { render, staticRenderFns } from "./StaffUploadApplications.vue?vue&type=template&id=23372492&scoped=true&"
import script from "./StaffUploadApplications.vue?vue&type=script&lang=js&"
export * from "./StaffUploadApplications.vue?vue&type=script&lang=js&"
import style0 from "./StaffUploadApplications.vue?vue&type=style&index=0&id=23372492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23372492",
  null
  
)

export default component.exports